import TemporaryAccessPassModal from './TemporaryAccessPassModal'

export default TemporaryAccessPassModal
